import React from 'react';
import './Calculator.scss';
import calcArrows from '../../assets/img/calcArrows.webp';
import calcImg from '../../assets/img/calcImg.webp';
import { useState,useEffect } from 'react';
import selectDown from '../../assets/img/selectDown.svg';
import selectUp from '../../assets/img/selectUp.svg';
import OutsideHook from '../../components/outsidehook/OutsideHook';


function Calculator({t}) {
    const [currentCurrency, setCurrentCurrency] = useState("PLN");
    const [ref, isShow,setIsShow] = OutsideHook(false);
    const [currencyValue, setCurrencyValue] = useState(0);
    const [outActive,setOutActive]= useState(false)

    const [consentAge, setConsentAge] = useState(false);
    const [consentCopyright, setConsentCopyright] = useState(false);

    const currencyData = ['PLN','EUR','USD'];

    const currencyItem = currencyData
    .filter(item => item !== currentCurrency)
    .map(item => (
      <div key={item} className="drop-down-item-currency" onClick={()=>{
        setCurrentCurrency(item);
        setIsShow(!isShow);
    }}>{item}</div>
  ))

  const setCurrencyValueHandler = (event) => {
    setCurrencyValue((prev) => {
        prev = event.target.value;
        return prev;
    });
};

const onToggleCheckAge = (event) => {
    setConsentAge((prev)=>{
        prev =!consentAge;
        return prev
    });  
}

const onToggleCheckCopyright = (event) => {
    setConsentCopyright((prev)=>{
        prev =!consentCopyright;
        return prev
    }); 
}
let clientPays = currencyValue;

let packageCost;
let payOut;
let payOutClean;
let pit =0;
    if(currentCurrency === 'PLN'){
        packageCost = 450;   
        payOutClean = clientPays - packageCost
    }
    if(currentCurrency === 'EUR'){
        packageCost = 80
        payOutClean = clientPays - packageCost
    }
    if(currentCurrency === 'USD'){
        packageCost = 90
        payOutClean = clientPays - packageCost
    }
    
    if(!consentAge && !consentCopyright){
        payOut = payOutClean
        pit = 0;
    }
    if(consentAge && !consentCopyright){
        payOut = payOutClean - payOutClean * 0.12
        pit = payOutClean * 0.12
    }
    if(consentAge && consentCopyright){
        payOut = payOutClean - payOutClean * 0.06
        pit = payOutClean * 0.06
    }
    if(!consentAge && consentCopyright){
        payOut = payOutClean
        pit = 0;
    }
    if(clientPays <= 0){
        pit = 0
    }

    useEffect(() => {
        if(payOut > 0){
            setOutActive(true)
        }else{
            setOutActive(false)
        }
    }, [payOut]);

  return (
    <div className="calculator-wrapper">
        <div className="calculator-content-wrapper">
            <div className="calculator-content">
                <div className="calc-image">
                    <img src={calcImg} alt="calculate" />
                </div>
                <div className="calc-info-wrapper">
                    <div className="calc-capture">
                        {t("calc_capture")}
                    </div>
                    <div className="calc-description">
                        {t("calc_description")}
                    </div>
                    <div className="calc-block-wrapper">
                        <div className="inputs-wrapper">
                            <div className="left-input-info">
                                <div className="input-capture">
                                    {t("calc_left_input")}
                                </div>
                                <div className="left-input">
                                    <input type="number" placeholder='10000' onChange={setCurrencyValueHandler}/>
                                    <div ref ={ref}  className="currency-drop-down">
                                        <div className="currency-drop-down-btn" onClick={() => {
                                            setIsShow(!isShow)
                                            }}>
                                            <div className="currency-label">{currentCurrency}</div>
                                            <span className='arrow-down' ><img src={isShow ? selectUp : selectDown} alt="select" /></span>
                                        </div>
                                        {isShow && (<div className="currency-drop-down-content">
                                            {currencyItem}
                                        </div>)}
                                    </div>
                                </div>
                            </div>
                            <div className="arrows"><img src={calcArrows} alt="arrows" /></div>
                            <div className="right-input-info">
                                <div className="input-capture">
                                    {t("calc_right_input")}
                                </div>
                                <div className="right-input">
                                    <div className="out-wrapper">
                                        <div className={`right-input-text  ${outActive ? 'active': ""}`}>
                                            {Math.round(payOut)}
                                        </div>
                                        <div className="currency">
                                            {currentCurrency}
                                        </div>
                                    </div>
                                </div>
                                <div className="input-checkboxs">
                                    <div className="checkbox">
                                        <input type="checkbox" onChange={onToggleCheckAge}/>
                                        <span className='confirm'>{t("calc_age_confirm")}</span>
                                    </div>
                                    <div className="checkbox">
                                        <input type="checkbox" onChange={onToggleCheckCopyright}/>
                                        <span className='confirm'>{t("calc_copyryght_confirm")}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='costs'>{t("costs")}</div>
                    </div>
                    <div className="bottom-tax">
                        <span className='tax'>{Math.round(pit)} {currentCurrency}</span> <span>{t("tax")}</span>
                    </div>
                    <div className="bottom-member">
                        <span className='member'>{packageCost} {currentCurrency}</span> <span>{t("membership")}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Calculator;